export const LIST_COUNTRIES = 'LIST_COUNTRIES';
export const LIST_STATES = 'LIST_STATES';
export const LIST_DISTRICTS = 'LIST_DISTRICTS';
export const LIST_WARDS = 'LIST_WARDS';
export const ADDRESS_CONFIG_RESET_COUNTRIES = 'ADDRESS_CONFIG_RESET_COUNTRIES';
export const ADDRESS_CONFIG_RESET_STATES = 'ADDRESS_CONFIG_RESET_STATES';
export const ADDRESS_CONFIG_RESET_DISTRICTS = 'ADDRESS_CONFIG_RESET_DISTRICTS';
export const ADDRESS_CONFIG_RESET_WARDS = 'ADDRESS_CONFIG_RESET_WARDS';
export const ADDRESS_CONFIG_RESET_ALL = 'ADDRESS_CONFIG_RESET_ALL';
